import {Stack} from "@mui/joy";
import {VenueCapsule} from "../venue/capsule.tsx";
import {useTranslation} from "react-i18next";
import {ReactNode, useCallback} from "react";
import {TriplegStatusCodes, useTriplegStatus} from "./transitUtils.ts";
import {useTruckStatus} from "../truck/truck.tsx";
import {ActionButton, ActionButtonProps} from "../components/ActionButton.tsx";
import {useArriveMutation} from "../tq/tqx.tsx";
import {mergeSx} from "../components/joyx.tsx";
import {useLastTriplegForTruck} from "../rpc/webrpc-client.gen.ts";

export interface ArriveButtonProps extends Omit<ActionButtonProps, "children" | "perform"> {
    truckId: string;
    depth: "full" | "brief";
}

export function ArriveButton(props: ArriveButtonProps) {
    const {
        truckId,
        depth,
        sx: inSx,
        ...rest
    } = props;
    const sx = mergeSx({}, inSx);
    const {t} = useTranslation();
    // const navigate = useNavigate();
    // const selfTqrv = useSelf();
    // const self = selfTqrv.data;
    const lastTriplegTqrv = useLastTriplegForTruck({truckId});
    const tripleg = lastTriplegTqrv.data;
    const triplegStatusTqrv
        = useTriplegStatus(tripleg ? {tripleg} : undefined);
    const {mutateAsync: arrive} = useArriveMutation();
    // const {admit, isSuccess: isAdmitterSuccess}
    //     = useAdmitter({tripleg, enabled: !!tripleg});

    const onArrive = useCallback(() => {
        if (!tripleg) {
            return Promise.resolve();
        }
        return arrive({tripleg})
            // .then(() => navigate({to: "/driver/next"}))
            ;
    }, [arrive, tripleg]);

    const truckStatusTqrv = useTruckStatus({truckId: truckId});

    let rv: ReactNode = null;

    if (!tripleg) {
        throw new Error("tripleg must exist in order to be able to arrive");
    }

    if (!triplegStatusTqrv.isSuccess || !truckStatusTqrv.isSuccess) {
        return null;
    }

    const truckStatus = truckStatusTqrv.data;
    const triplegStatus = triplegStatusTqrv.data

    if (truckStatus.currentDestination) {
        switch (depth) {
            case "full":
                switch (triplegStatus.code) {
                    case TriplegStatusCodes.EN_ROUTE:
                        rv = <ActionButton sx={sx} {...rest} perform={onArrive}>
                            <Stack direction="column" spacing={1.4} sx={{px: 4, py: 2}}>
                                <VenueCapsule venue={truckStatus.currentDestination}/>
                                {t("driver.arrive")}
                            </Stack>
                        </ActionButton>
                        break;
                    // case TriplegStatusCode.AWAITING_ADMISSION:
                    //     rv = <ActionButton sx={sx} {...rest} perform={onAdmit}>
                    //         <Stack direction="column" spacing={1.4} sx={{px: 4, py: 2}}>
                    //             <VenueCapsule venue={truckStatus.currentDestination}/>
                    //             {t("driver.admit")}
                    //         </Stack>
                    //     </ActionButton>
                    //     break;
                }
                break;
            case "brief":
                switch (triplegStatus.code) {
                    case TriplegStatusCodes.EN_ROUTE:
                        rv = <ActionButton sx={sx} {...rest} perform={onArrive}>
                            {t("driver.arrive")}
                        </ActionButton>
                        break;
                    // case TriplegStatusCode.AWAITING_ADMISSION:
                    //     rv = <ActionButton sx={sx} {...rest} perform={onAdmit}>
                    //         {t("driver.admit")}
                    //     </ActionButton>
                    //     break;
                }
                break;
        }
    }

    return rv;
}


